/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 17V9M21 15V6M9 9V7.35798C9 6.45276 9 6.00015 9.15937 5.6252C9.29996 5.29443 9.52709 5.00766 9.81686 4.79505C10.1453 4.55404 10.5859 4.45037 11.4671 4.24304L17.1063 2.91616C18.413 2.60872 19.0663 2.455 19.5816 2.61165C20.0654 2.7587 20.4755 3.08352 20.7295 3.52074C21 3.98654 21 4.6577 21 6V6M9 9L21 6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9 19C9 20.6569 7.65685 22 6 22C4.34315 22 3 20.6569 3 19C3 17.3431 4.34315 16 6 16C7.65685 16 9 17.3431 9 19ZM9 19V13M21 16C21 17.6569 19.6569 19 18 19C16.3431 19 15 17.6569 15 16C15 14.3431 16.3431 13 18 13C19.6569 13 21 14.3431 21 16ZM21 16V10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path
					d="M9 19C9 20.6569 7.65685 22 6 22C4.34315 22 3 20.6569 3 19C3 17.3431 4.34315 16 6 16C7.65685 16 9 17.3431 9 19Z"
					fill="currentColor"
				/>
				<path
					d="M21 16C21 17.6569 19.6569 19 18 19C16.3431 19 15 17.6569 15 16C15 14.3431 16.3431 13 18 13C19.6569 13 21 14.3431 21 16Z"
					fill="currentColor"
				/>
				<path
					d="M9 7.35798C9 6.45276 9 6.00015 9.15937 5.6252C9.29996 5.29443 9.52709 5.00766 9.81686 4.79505C10.1453 4.55404 10.5859 4.45037 11.4671 4.24304L17.1063 2.91616C18.413 2.60872 19.0663 2.455 19.5816 2.61165C20.0654 2.7587 20.4755 3.08352 20.7295 3.52074C21 3.98654 21 4.6577 21 6L9 9V7.35798Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M9 19V9M9 19C9 20.6569 7.65685 22 6 22C4.34315 22 3 20.6569 3 19C3 17.3431 4.34315 16 6 16C7.65685 16 9 17.3431 9 19ZM21 16V6M21 16C21 17.6569 19.6569 19 18 19C16.3431 19 15 17.6569 15 16C15 14.3431 16.3431 13 18 13C19.6569 13 21 14.3431 21 16ZM9 9V7.35798C9 6.45276 9 6.00015 9.15937 5.6252C9.29996 5.29443 9.52709 5.00766 9.81686 4.79505C10.1453 4.55404 10.5859 4.45037 11.4671 4.24304L17.1063 2.91616C18.413 2.60872 19.0663 2.455 19.5816 2.61165C20.0654 2.7587 20.4755 3.08352 20.7295 3.52074C21 3.98654 21 4.6577 21 6V6M9 9L21 6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.75 9.5856L20.25 6.9606V12.9997C19.6233 12.529 18.8442 12.25 18 12.25C15.9289 12.25 14.25 13.9289 14.25 16C14.25 18.0711 15.9289 19.75 18 19.75C20.0711 19.75 21.75 18.0711 21.75 16V6.00002V5.96669C21.75 5.32388 21.75 4.79359 21.7134 4.36753C21.6757 3.92858 21.5942 3.51638 21.378 3.14409C21.0289 2.5429 20.4649 2.09627 19.7998 1.89409C19.3878 1.76888 18.9679 1.78396 18.532 1.8478C18.1089 1.90977 17.5927 2.03124 16.967 2.17848L16.967 2.17848L16.9345 2.18611L11.2953 3.513L11.2698 3.51901C10.8509 3.61755 10.4979 3.7006 10.2103 3.7908C9.90781 3.88566 9.62957 4.00226 9.37319 4.19037C8.97475 4.48272 8.66245 4.87703 8.46913 5.33184C8.34474 5.62449 8.29496 5.92204 8.27191 6.2382C8.24998 6.53885 8.24999 6.90147 8.25 7.33176V7.358V9.00002V15.9997C7.62325 15.529 6.8442 15.25 6 15.25C3.92893 15.25 2.25 16.9289 2.25 19C2.25 21.0711 3.92893 22.75 6 22.75C8.07107 22.75 9.75 21.0711 9.75 19V9.5856Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M21 16V6M21 16C21 17.6569 19.6569 19 18 19C16.3431 19 15 17.6569 15 16C15 14.3431 16.3431 13 18 13C19.6569 13 21 14.3431 21 16ZM9 9V19C9 20.6569 7.65685 22 6 22C4.34315 22 3 20.6569 3 19C3 17.3431 4.34315 16 6 16M9 9V7.35798C9 6.45276 9 6.00015 9.15937 5.6252C9.29996 5.29443 9.52709 5.00766 9.81686 4.79505C10.1453 4.55404 10.5859 4.45037 11.4671 4.24304L17.1063 2.91616C18.413 2.60872 19.0663 2.455 19.5816 2.61165C20.0654 2.7587 20.4755 3.08352 20.7295 3.52074C21 3.98654 21 4.6577 21 6V6M9 9L14 7.75M21 6L18 6.75"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9 19V9M9 19C9 20.6569 7.65685 22 6 22C4.34315 22 3 20.6569 3 19C3 17.3431 4.34315 16 6 16C7.65685 16 9 17.3431 9 19ZM21 16V6M21 16C21 17.6569 19.6569 19 18 19C16.3431 19 15 17.6569 15 16C15 14.3431 16.3431 13 18 13C19.6569 13 21 14.3431 21 16ZM9 9V7.35798C9 6.45276 9 6.00015 9.15937 5.6252C9.29996 5.29443 9.52709 5.00766 9.81686 4.79505C10.1453 4.55404 10.5859 4.45037 11.4671 4.24304L17.1063 2.91616C18.413 2.60872 19.0663 2.455 19.5816 2.61165C20.0654 2.7587 20.4755 3.08352 20.7295 3.52074C21 3.98654 21 4.6577 21 6V6M9 9L21 6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.25 15.9998V6.96036L9.75 9.58536V18.9998C9.75 19.414 9.41421 19.7498 9 19.7498C8.58579 19.7498 8.25 19.414 8.25 18.9998V8.99977V7.35775V7.33151V7.3315C8.24999 6.90122 8.24998 6.5386 8.27191 6.23796C8.29497 5.92179 8.34474 5.62425 8.46914 5.33159C8.66245 4.87678 8.97475 4.48247 9.37319 4.19013C9.62958 4.00201 9.90781 3.88541 10.2103 3.79055C10.4979 3.70035 10.8509 3.6173 11.2697 3.51876L11.2698 3.51876L11.2953 3.51275L16.9346 2.18587L16.967 2.17824L16.967 2.17823C17.5927 2.03099 18.1089 1.90953 18.532 1.84756C18.9679 1.78371 19.3878 1.76864 19.7998 1.89384C20.4649 2.09603 21.0289 2.54266 21.378 3.14384C21.5942 3.51613 21.6757 3.92834 21.7134 4.36729C21.75 4.79335 21.75 5.32363 21.75 5.96645V5.99977V15.9998C21.75 16.414 21.4142 16.7498 21 16.7498C20.5858 16.7498 20.25 16.414 20.25 15.9998Z"
				fill="currentColor"
			/>
			<path
				d="M18 12.25C15.9289 12.25 14.25 13.9289 14.25 16C14.25 18.0711 15.9289 19.75 18 19.75C20.0711 19.75 21.75 18.0711 21.75 16C21.75 13.9289 20.0711 12.25 18 12.25Z"
				fill="currentColor"
			/>
			<path
				d="M6 15.25C3.92893 15.25 2.25 16.9289 2.25 19C2.25 21.0711 3.92893 22.75 6 22.75C8.07107 22.75 9.75 21.0711 9.75 19C9.75 16.9289 8.07107 15.25 6 15.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
